/**
 * @file   network.js
 * @author zhengchanglong<zhengchanglong@baidu.com>
 * @date   2019-09-03
 * @doc    https://github.com/axios/axios#request-config
 */

import axios from 'axios';
import qs from 'qs';
import {each, hasOwnProperty, assign, isPlain} from './obj';

const TIMEOUT = 30000;
const HEADERS = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-bdsToken': (window.INITIAL_DATA && window.INITIAL_DATA.bdsToken) || ''
};
const PARAMS_BLACKLIST = [undefined, '', NaN, null];
const DEFAULT_CONFIG = {
    url: '',
    method: 'get',
    baseURL: '',
    transformRequest: [function (data, headers) {
        // 如果 data 是 Buffer, ArrayBuffer, FormData 和 Stream 的实例直接返回
        if (isPlain(data)) {
            // 移除无意义参数
            each(data, (value, key) => {
                if (hasOwnProperty(data, key) && PARAMS_BLACKLIST.includes(value)) {
                    delete data[key];
                    console.warn(`值为『${value}』的参数『${key}』被过滤了~`);
                }
            });

            data = qs.stringify(data);
        }

        return data;
    }],
    transformResponse: [function (res) {
        return res;
    }],
    headers: HEADERS,
    params: {
    },
    paramsSerializer(params) {
        return qs.stringify(params, {arrayFormat: 'brackets'});
    },
    data: {
    },
    timeout: 30000,
    withCredentials: false,
    responseType: 'json',
    responseEncoding: 'utf8',
    onUploadProgress(progressEvent) {
    },
    onDownloadProgress(progressEvent) {
    },
    maxContentLength: 2000,
    validateStatus(status) {
        return status >= 200 && status < 300;
    },
    maxRedirects: 5,
    // 自定义字段，axios不支持
    errorMsg: {}
    // socketPath: null,
    // httpAgent: new http.Agent({ keepAlive: true }),
    // httpsAgent: new https.Agent({ keepAlive: true }),
    // proxy: {
    //     host: '127.0.0.1',
    //     port: 9000,
    //     auth: {
    //         username: '',
    //         password: ''
    //     }
    // },
    // cancelToken: new CancelToken(function (cancel) {
    // })
};

export default class Network {
    constructor(config) {
        config = assign({}, DEFAULT_CONFIG, config);
        this.config = config;
        this.errorMsg = config.errorMsg;
        this.http = axios.create(config);
    }
    handleResponse(response) {
        const res = response.data;

        // TODO 网络异常处理

        // 接口异常处理
        if (res.errCode !== 0) {
            const error = new Error(this.errorMsg[res.errCode] || res.errMsg);
            error.code = res.errCode;

            throw error;
        }

        return res.data;
    }
    async request(config) {
        const res = await this.http.request(config);
        return this.handleResponse(res);
    }
    async get(url, params, config = {}) {
        const conf = assign(config, {params});
        const res = await this.http.get(url, conf);
        return this.handleResponse(res);
    }
    async head(url, params, config = {}) {
        const conf = assign(config, {params});
        const res = await this.http.head(url, conf);
        return this.handleResponse(res);
    }
    async delete(url, params, config = {}) {
        const conf = assign(config, {params});
        const res = await this.http.delete(url, conf);
        return this.handleResponse(res);
    }
    async post(url, data, config) {
        const res = await this.http.post(url, data, config);
        return this.handleResponse(res);
    }
    async put(url, data, config) {
        const res = await this.http.post(url, data, config);
        return this.handleResponse(res);
    }
    async patch(url, data, config) {
        const res = await this.http.post(url, data, config);
        return this.handleResponse(res);
    }
    static uploadImage(opts = {}) {
        const defaultOpts = {
            url: '',
            fileName: '',
            blob: '',
            headers: HEADERS,
            timeout: TIMEOUT,
            success() {},
            fail() {},
            progress() {}
        };
        const vm = this;
        const xhr = new XMLHttpRequest();
        const formData = new FormData();
        let percentComplete = 0;

        opts = assign({}, defaultOpts, opts);
        formData.append(opts.fileName, opts.blob, 'image.jpg');
        xhr.upload.onprogress = function (evt) {
            if (evt.lengthComputable) {
                percentComplete = Math.round(evt.loaded / evt.total * 100);
                opts.progress(percentComplete);
            }
        };
        xhr.onload = function () {
            const res = JSON.parse(this.responseText);

            if (res.errCode === 0) {
                opts.success(res);
                return;
            }

            opts.fail(new Error(res.errMsg));
        };
        xhr.onabort = xhr.onerror = opts.fail;

        // 在IE中，某些属性只能放在open()和send()方法之间进行设置
        xhr.open('post', opts.url);
        // 设置请求超时时间为8s
        xhr.timeout = opts.timeout;
        xhr.ontimeout = opts.fail;
        each(opts.headers, (value, key) => {
            xhr.setRequestHeader(key, value);
        });
        xhr.send(formData);
    }
}
